import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CountryTag, Reimbursement } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { ReimbursementsService } from 'src/app/services/reimbursements/reimbursements.service';

@Component({
    selector: 'app-reimbursements-form',
    templateUrl: './reimbursements-form.component.html',
    styleUrls: ['./reimbursements-form.component.scss'],
})
export class ReimbursementsFormComponent implements OnInit {
    @Input() countryTag: string;
    destroy$ = new Subject();
    loading = false;
    reimbursementForm: FormGroup;

    constructor(private fb: FormBuilder, private reimbursementsService: ReimbursementsService, private toast: ToastrService) {}

    ngOnInit(): void {
        this.buildForm();
    }

    buildForm() {
        this.reimbursementForm = this.fb.group({
            token: this.fb.control('', [Validators.required]),
            amount: this.fb.control('', [Validators.required, this.numberCommaDotValidator()]),
        });
    }

    numberCommaDotValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const valid = /^[0-9.,]*$/.test(control.value);
            return valid ? null : { invalidFormat: true };
        };
    }

    submitForm() {
        this.reimbursementForm.markAllAsTouched();
        if (this.reimbursementForm.invalid) {
            return;
        }
        let countryCurrency = this.countryTag === CountryTag.CAN ? 'CAD' : 'USD';
        let payload: Reimbursement = this.reimbursementForm.value;
        payload.amount = Number(this.reimbursementForm.value.amount.replace(',', '.'));
        this.loading = true;
        this.reimbursementsService
            .postReimbursement(payload)
            .pipe(
                takeUntil(this.destroy$),
                tap((res) => this.toast.success(`The refund has been processed in the currency of the city (${countryCurrency})`, 'Success', { enableHtml: true })),
                tap(() => (this.loading = false)),
                catchError((error) => {
                    this.toast.error('An error occured. View browser console for details', 'Error');
                    console.log('error', error);
                    this.loading = false;
                    return of();
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
